<template>
    <div class=" bg-gray-100 pt-10  md:mt-10 text-gray-500 pb-5">
        <section class="font-poppins md:text-sm w-full ">

            <div class="flex justify-between md:mt-3 ml-4 mr-4 lg:flex-col">
                <div class="mt-10">
                    <router-link to="/"><img style="width:10rem"
                            src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg"
                            alt="logo"></router-link>
                </div>
                <div class="lg:mt-4">
                    <p class="pr-8 pb-2 border-b border-gray-500 font-medium lg:border-0 lg:font-semibold">COMPANY</p>
                    <div class="mt-4">
                        <ul>
                            <li> <router-link to="/faqs">FAQ'S</router-link> </li>
                            <li> <router-link to="/contact">Contact</router-link> </li>
                        </ul>
                    </div>
                </div>

                <div class="lg:mt-2">
                    <p class="pr-8 pb-2 border-b lg:border-0 lg:mt-2 lg:font-semibold border-gray-500 font-medium">LEGAL
                    </p>
                    <div class="mt-4">
                        <ul>
                            <li> <router-link to="/terms-policy">Privacy Policy</router-link> </li>
                            <li> <router-link to="/terms-policy">Terms and Conditions</router-link> </li>
                        </ul>
                    </div>
                </div>

                <div class="lg:mt-2">
                    <p class="pr-8 pb-2 border-b border-gray-500 font-medium lg:border-0 lg:mt-2 lg:font-semibold">
                        SOCIAL</p>
                    <div class="mt-4 flex">
                        <a href="https://twitter.com/_CarryGoNg?t=hr9WEcQiMa56dd8G6ilY-g&s=09" target="_blank"><img
                                class="  md:w-8 md:h-8" src="../LandingPages/Images/twitter-icon.png" alt="logo"></a>
                        <a href="https://www.facebook.com/CarryGo-Logistech-100760155865136/" target="_blank"><i
                                class="fa fa-facebook fa-2x text-blue-800 mt-1 ml-1"></i></a>
                        <a href="https://instagram.com/carrygo_ng?utm_medium=copy_link" target="_blank"><img
                                class="ml-2 md:w-8 md:h-8" src="../LandingPages/Images/instagram-icon.png"
                                alt="logo"></a>
                    </div>
                </div>

                <div class="lg:mt-2 lg:mb-6">
                    <p class="pr-8 pb-2 border-b border-gray-500 font-medium lg:border-0 lg:mt-2 lg:font-semibold">SIGN
                        UP TO MAILING LIST</p>
                    <div class="mt-4 flex lg:flex-col">
                        <div>
                            <input class=" w-full md:w-1/2 border border-gray-500 p-2 rounded-xl" type="email"
                                name="email" id="email" placeholder="Email Address" v-model="email">
                            <p v-if="emailValidity === 'invalid'" class="text-red-500 text-xs">please this filed cannot
                                be empty.</p>
                        </div>

                        <button @click="subscribe"
                            class="bg-blue-800 ml-2 lg:ml-0 lg:w-1/4 lg:mt-3 text-white p-2 rounded-xl">Sign Up<i
                                v-if="isLoading" class="fa fa-spin fa-spinner"></i></button>
                    </div>
                </div>
            </div>
            <div class="text-center text-sm mt-10 md:mt-6  text-gray-300 ">
                <p>Copyright &copy; CarryGo Logistech, {{ date }}</p>
            </div>

            <SuccessModal v-show="isModalVisible" @close="closeModal" :message="message" />
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import { baseUrl } from '../../Config';
const url = baseUrl;
import SuccessModal from '../LandingPages/SuccessfulModal.vue'
export default {
    components: {
        SuccessModal
    },
    data() {
        return {
            email: "",
            emailValidity: "",
            isLoading: false,
            isModalVisible: false,
            message: "",
            date: new Date().getFullYear()
        }
    },

    methods: {
        closeModal() {
            this.isModalVisible = false
        },
        subscribe() {
            if (!this.email) {
                this.emailValidity = "invalid"
                setTimeout(() => {
                    this.emailValidity = ""
                }, 3000);
            } else {
                this.isLoading = true
                axios({
                    method: 'POST',
                    url: `${url}/v1/web/extras/subscribe`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key': '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data: {
                        email: this.email
                    }
                })
                    .then((res) => {
                        res.json;
                        this.isLoading = false;
                        this.message = "You have been successfully added to our mailing list. you will receive newsletters, and promotional mails from us."
                        this.isModalVisible = true;
                    })
                    .catch((err) => {
                        if (err) {
                            this.isModalVisible = true;
                            this.message = "oops something went wrong"
                        }
                        this.isLoading = false;
                    })
            }
        }
    }
}
</script>
